import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeOuiNon } from '../models/TypeOuiNon';
@Component({
  selector: 'app-type-oui-non',
  templateUrl: './type-oui-non.component.html'
})
export class TypeOuiNonComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeOuiNon'
  @Input() parentForm: FormGroup;
  @Input() candidatsDejaSelectionnes : TypeOuiNon;
  @Input() label: String;

  constructor() { }

  public ngOnInit() {
  }








  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

